import { Box, Chip } from '@mui/material';
import { blue, yellow } from '@mui/material/colors';
import Grid from '@mui/material/Grid2';
import { PHIO_COLORS } from 'config/theme';
import React from 'react';
import Tab from '@mui/material/Tab';
import { useLocation, useParams } from 'react-router-dom';
import { DischargeOptions } from './components/DischargeButton';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import DischargeSettingsForm from './components/DischargeSettingsForm';
import { logScreenView } from 'utils/gaLog';

const PhioengageDischargeSettings = () => {
    const [tabsValue, setTabsValue] = React.useState('0'); // Default to the first tab
    const params = useParams<{ id: string }>();

    const { state } = useLocation();

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setTabsValue(String(newValue));
    };

    // Page view logging
    React.useEffect(() => {
        // Log screen view event
        logScreenView('discharge_config_edit_view', {
            customer_name: state.clientName ?? 'unknown',
            customer_id: params.id ?? 'unknown'
        });
    }, [state.clientName, params.id]);

    return (
        <Grid container spacing={0} sx={{ background: 'white' }}>
            <Grid size={{ sm: 12 }}>
                <Box
                    sx={(theme) => ({
                        width: '100%',
                        height: 80,
                        backgroundColor: PHIO_COLORS.dark,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        paddingLeft: 2
                    })}
                >
                    <Chip
                        label={state.clientName}
                        variant="filled"
                        sx={{ backgroundColor: PHIO_COLORS.primaryBlue, color: '#fff' }}
                    />
                    <Chip
                        label={
                            state.preset ? state?.preset?.split('_').join(' ') : 'Missing Usecase'
                        }
                        variant="outlined"
                        sx={(theme) => ({
                            color: yellow[500],
                            border: `2px solid ${yellow[500]}`,
                            textTransform: 'capitalize'
                        })}
                    />
                </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 12 }}>
                <TabContext value={tabsValue}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider', padding: 1 }}>
                        <TabList
                            onChange={handleChange}
                            aria-label="Settings Tabs"
                            sx={{
                                background: blue[50],
                                marginLeft: 1,
                                marginRight: 1,
                                borderRadius: 2
                            }}
                        >
                            {DischargeOptions.map((option, index) => (
                                <Tab
                                    key={index}
                                    label={option.name}
                                    value={`${index}`}
                                    sx={{ textTransform: 'none' }}
                                />
                            ))}
                        </TabList>
                    </Box>
                    <TabPanel value="0">
                        <DischargeSettingsForm
                            customerId={params.id ?? ''}
                            dischargeCode={DischargeOptions[0].id}
                            isTimeSensitive
                            customerName={state.clientName}
                        />
                    </TabPanel>
                    <TabPanel value="1">
                        <DischargeSettingsForm
                            customerId={params.id ?? ''}
                            dischargeCode={DischargeOptions[1].id}
                            isTimeSensitive
                            customerName={state.clientName}
                        />
                    </TabPanel>
                    <TabPanel value="2">
                        <DischargeSettingsForm
                            customerId={params.id ?? ''}
                            dischargeCode={DischargeOptions[2].id}
                            customerName={state.clientName}
                        />
                    </TabPanel>
                    <TabPanel value="3">
                        <DischargeSettingsForm
                            customerId={params.id ?? ''}
                            dischargeCode={DischargeOptions[3].id}
                            customerName={state.clientName}
                        />
                    </TabPanel>
                    <TabPanel value="4">
                        <DischargeSettingsForm
                            customerId={params.id ?? ''}
                            dischargeCode={DischargeOptions[4].id}
                            customerName={state.clientName}
                        />
                    </TabPanel>
                </TabContext>
            </Grid>
        </Grid>
    );
};

export default PhioengageDischargeSettings;
